import { __assign, __rest } from "tslib";
import { Chip as MaterialChip, createStyles, makeStyles, useTheme, } from '@material-ui/core';
import React from 'react';
import { CheckIcon } from '../../icons/draft';
var useStyles = makeStyles(function (theme) {
    return createStyles({
        root: {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            '& > .MuiChip-icon': {
                display: 'none',
            },
        },
        clickableColorSecondary: {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            '&:active, &:hover, &:focus': {
                backgroundColor: theme.palette.secondary.main,
                color: theme.palette.secondary.contrastText,
            },
        },
        outlined: {
            backgroundColor: theme.palette.background.paper,
            '& > .MuiChip-icon': {
                marginLeft: 0,
                display: 'inline',
            },
        },
        outlinedSecondary: {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            borderWidth: 2,
            '&:active, &:hover, &:focus': {
                color: theme.palette.text.primary,
            },
        },
        icon: {
            width: theme.spacing(2),
            height: theme.spacing(2),
            marginLeft: 0,
            marginRight: theme.spacing(0.5),
        },
        label: {
            paddingLeft: 0,
            paddingRight: 0,
        },
    });
});
export var Chip = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'secondary' : _b, _c = _a.size, size = _c === void 0 ? 'medium' : _c, _d = _a.variant, variant = _d === void 0 ? 'default' : _d, icon = _a.icon, props = __rest(_a, ["color", "size", "variant", "icon"]);
    var classes = useStyles();
    var theme = useTheme();
    return (React.createElement(MaterialChip, __assign({ classes: classes, color: color, size: size, variant: variant, icon: icon || React.createElement(CheckIcon, { size: "s", color: theme.palette.secondary.main }) }, props)));
};
//# sourceMappingURL=Chip.js.map